<template>
  <div class="guide-popup">
    <div class="guide-popup-shade" @click="hidePopup"></div>
    <div class="guide-popup-content">
      <p class="guide-popup-title">{{ letter.voucherAddHome }}</p>
      <p class="guide-popup-sub-title">{{ letter.voucherAddHomeTipOne }}</p>
      <div class="guide-popup-img-wrap">
        <div class="phone"></div>
        <img class="logo" v-if="logo" :src="logo" alt="logo" />
        <div class="shade"></div>
        <img class="logo-big" v-if="logo" :src="logo" alt="logo" />
      </div>
      <div class="guide-popup-tip">
        {{ letter.voucherAddHomeTipTwo }} <span class="share"></span>
      </div>
      <div class="guide-popup-tip tip2">
        {{ letter.voucherAddHomeTipThree }} <span class="mark"></span>
      </div>
      <a
        class="guide-popup-close j-click-coupon-close"
        href="javascript:;"
        @click="hidePopup"
      ></a>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex';
export default {
  name: 'SafariPwaGuidePopup',
  computed: {
    picList() {
      return this.$store.state.page.picList;
    },
    letter() {
      return this.$store.state.letter;
    },
    logo() {
      return this.picList?.icon || '';
    }
  },
  methods: {
    hidePopup() {
      this.$emit('closePopup');
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';
.guide-popup {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;

  &-shade {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
  &-content {
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    width: 708px;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 10px;
  }
  &-title {
    margin-top: 39px;
    margin-bottom: 10px;
    text-align: center;
    font-size: 32px;
    color: #333333;
  }
  &-sub-title {
    text-align: center;
    font-size: 26px;
    color: #666666;
    margin-bottom: 20px;
  }
  &-img-wrap {
    position: relative;
    background: url($commonImg + 'phone.png') no-repeat;
    width: 363px;
    height: 306px;
    margin: 10px auto;
    .phone {
      position: absolute;
      width: 181px;
      height: 306px;
      left: 0;
      top: 0;
      background: url($commonImg + 'phone.png') no-repeat;
    }
    .logo {
      position: absolute;
      width: 21px;
      height: 21px;
      left: 62px;
      top: 133px;
      border-radius: 40px;
    }
    .shade {
      position: absolute;
      width: 229px;
      height: 193px;
      left: 62px;
      top: 52px;
      background: url($commonImg + 'juxing.png') no-repeat;
    }
    .logo-big {
      position: absolute;
      width: 192px;
      height: 192px;
      right: 0;
      top: 52px;
      border-radius: 40px;
    }
  }
  &-tip {
    width: 100%;
    color: #333;
    font-size: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    .share {
      width: 94px;
      height: 94px;
      background: url($commonImg + 'safari-guide-send.png') no-repeat;
    }
    .mark {
      width: 105px;
      height: 101px;
      background: url($commonImg + 'safari-guide-mark.png') no-repeat;
    }
    &.tip2 {
      margin-bottom: 35px;
    }
  }

  &-close {
    position: absolute;
    right: 32px;
    top: 23px;
    width: 35px;
    height: 35px;
    background: url($commonImg + 'close.png') no-repeat;
    background-size: cover;
    cursor: pointer;
  }
}
</style>
